import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import styles from "assets/jss/material-kit-react/views/aboutUsPage.js";
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(styles);

export default function Summary() {
  const classes = useStyles();
  const preventDefault = (event) => event.preventDefault();

  return (
    <div className={classes.fastAccess+" "+classes.justify}>
            <p>
         کمپ آموزشی شریف مدت هاست که به عنوان برگزار کننده دوره های آموزشی آنلاین و حضوری، رویدادهای برنامه نویسی و نمایشگاه های آنلاین و حضوری  فعالیت می‌کند.
          </p>
          <p>
دوره های آموزشی با هدف آموزش نیروهای متخصص و با تمرکز بر روی مهارت های سخت و نرم مورد نیاز شرکت ها تعریف شده و به صورت حضوری و غیرحضوری در محل شرکت شما یا آموزشگاه برگزار می شود.</p>
 <p>
همچنین رویدادهای برنامه نویسی مختلف با هدف یافتن افراد مستعد در این حوزه و با توجه به نیازهای شرکت های مختلف حوزه فناوری اطلاعات تعریف و برگزار میشود.</p>
          <p>
دوره ها و رویدادها با مدرک معتبر آموزشی از دانشگاه ارائه می‌شود.</p>
<br />
<p className={classes.Center}>
                                    <Button variant="outlined" target='_blank' href="http://aryaradco.ir/"  disableElevation>
                                    بیشتر بدانید...
                                    </Button>
</p>
    </div>
  );
}
